import Component from '../vendor/Component'
import KlevuRecsApiLayer from './KlevuRecsApiLayer'

export default class CartDrawerUpsells extends Component {
  constructor(elem, theme, options, ctx) {
    super(elem, theme, options, ctx)

    this.apiLayer = new KlevuRecsApiLayer()
    this._mobileSwiper = this._elem.querySelector('[data-cart-drawer-recs-el="mobileSwiper"]')
    this._desktopSwiper = document.querySelector('[data-cart-drawer-recs-el="desktopSwiper"]')

    this._mobileSwiperWrapper = this._elem.querySelector('[data-cart-drawer-recs-el="mobileSwiperWrapper"]')
    this._desktopSwiperWrapper = document.querySelector('[data-cart-drawer-recs-el="desktopSwiperWrapper"]')
    this._cartDrawer = document.querySelector('.dm-side-cart')

    this._mobileCarousel = {}
    this._desktopCarousel = {}
  }

  mount() {
    this.setupListeners()

    if (this._elem.dataset.firstCartItem !== '' && this._elem.dataset.firstCartItemId !== '') {
      this.renderCarouselContent(this._elem.dataset.firstCartItem, this._elem.dataset.firstCartItemId)
    }
  }

  setupListeners() {
    window.addEventListener('cart:Refreshed', (event) => {
      this.destroyRecCarousels()

      if (event.detail.cart.item_count > 0) {
        const variantId = event.detail.cart.items[0].variant_id
        const productId = event.detail.cart.items[0].product_id

        this.renderCarouselContent(variantId, productId)
      }
    })
  }

  async renderCarouselContent(variantId, productId) {
    const productData = await this.fetchProductData(variantId)

    const filteredData = productData.filter(
      item => item.itemGroupId !== String(productId)
    );

    if (filteredData.length > 0) {
      this.createCarouselItems(filteredData).then((items) => {
        this.renderCarousel(items)
      })

      this._cartDrawer.classList.remove('dm-side-cart--no-recs')
    } else {
      this._cartDrawer.classList.add('dm-side-cart--no-recs')
    }
  }

  async fetchProductData(variantId) {
    const apiResponse = await this.apiLayer.fetchAlsoBought(variantId)
    return apiResponse.queryResults[0]?.records ?? []
  }

  async createCarouselItems (productData) {
    const fragment = document.createDocumentFragment();

    const listItemPromises = productData.map(async (product) => {
      const productCardElement = await this.fetchProductCard(product);
      const listItem = document.createElement('li');
      listItem.classList.add('swiper-slide', 'dm-side-cart__recs-item');
      listItem.appendChild(productCardElement);

      return listItem;
    });

    const listItems = await Promise.all(listItemPromises);

    listItems.forEach(listItem => {
      fragment.appendChild(listItem);
    });

    return fragment
  }

  fetchProductCard (product) {
    const productHandle = product.url.split('/').pop()

    return fetch(`/products/${productHandle}?section_id=dm-cart-drawer-product-card`)
      .then(response => {
        if (!response.ok) throw new Error('Failed to fetch quick add section');
        return response.text();
      })
      .then(text => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        return html.querySelector('.dm-drawer-product-card--rec');
      });
  }

  renderCarousel (fragment) {
    const desktopSwiperWrapper = document.querySelector('[data-cart-drawer-recs-el="desktopSwiperWrapper"]')
    const mobileSwiperWrapper = document.querySelector('[data-cart-drawer-recs-el="mobileSwiperWrapper"]')

    desktopSwiperWrapper.appendChild(fragment.cloneNode(true))
    mobileSwiperWrapper.appendChild(fragment.cloneNode(true))

    window.dispatchEvent(new CustomEvent('pushCart:recsRendered'));

    this.initDesktopCarousel()
    this.initMobileCarousel()
  }

  initMobileCarousel() {
    if (this._mobileSwiper) {
      this._mobileCarousel = new window.swiper(this._mobileSwiper, {
        spaceBetween: 5,
        slidesPerView: 2.4,
        loop: false,
        navigation: {
          nextEl: '[data-cart-drawer-recs-el="next"]',
          prevEl: '[data-cart-drawer-recs-el="prev"]',
        },
      });
    }
  }

  initDesktopCarousel() {
    if (this._desktopSwiper) {
      this._desktopCarousel = new window.swiper(this._desktopSwiper, {
        spaceBetween: 20,
        direction: "vertical",
        freeMode: true,
        slidesPerView: "auto",
        mousewheel: true,
      });
    }
  }

  destroyRecCarousels() {
    if (Object.keys(this._mobileCarousel).length !== 0) {
      this._mobileCarousel.destroy()
      this._desktopCarousel.destroy()

      this._mobileSwiperWrapper.innerHTML = ''
      this._desktopSwiperWrapper.innerHTML = ''
    }
  }
}
